import { useId, useState } from "react";
import { Spinner } from "./Spinner";

/** Keep the footer compact; the native popover also works with touch, keyboard and outside-click dismissal. */
export function BlogSaveStatus({ saved, label, detail, loading = false, refreshing = false }: { saved: boolean; label: string; detail: string; loading?: boolean; refreshing?: boolean }) {
  const id = useId();
  const [position, setPosition] = useState({ left: 16, bottom: 56 });
  return <span className="bw-blog-foot-text">
    <span className="bw-blog-status-spinner" aria-hidden="true">{(loading || refreshing) && <Spinner />}</span>
    {refreshing && !loading && <span className="bw-blog-status-label">Refreshing blog… </span>}
    {saved ? <>
      <button type="button" className="bw-btn bw-btn--text bw-blog-saved" popoverTarget={id} aria-describedby={id} onClick={event => {
        const rect = event.currentTarget.getBoundingClientRect();
        setPosition({ left: Math.max(16, Math.min(rect.left, window.innerWidth - 296)), bottom: window.innerHeight - rect.top + 8 });
      }}>Saved</button>
      <span id={id} popover="auto" role="tooltip" className="bw-blog-save-tooltip" style={position}>{detail}</span>
    </> : label}
  </span>;
}
